<mat-menu xPosition="before">
  <div class="menu-icon-wrapper">
    <!-- All role can view project details-->
    <button mat-menu-item (click)="openEditProjectDialog()" *ngIf="!showProjectSettingsOption">
      <div class="menu-icon-list">
        <div class="menu-icon-container">
          <img src="assets/images/icons/edit.svg" class="menu-icon" />
          <span class="vertical-dot-menu-text-font"> Project Details </span>
        </div>
      </div>
    </button>
    <!-- Check if the user is platform admin and project status is "Created", then enable it -->
    <button mat-menu-item (click)="configureFabricWorkspace()" *ngIf="
        project.status === projectStatusEnum.CREATED.toString() &&
        !project.fabricWorkspaceConfigured &&
        userService.userHasPlatformAdminRole
      ">
      <div class="menu-icon-list">
        <div class="menu-icon-container">
          <img src="assets/images/icons/project-configuration.svg" class="menu-icon" />
          <span class="vertical-dot-menu-text-font"> Configure Fabric Workspace </span>
        </div>
      </div>
    </button>

    <!-- Check if the user is platform admin and project status is "Created", then enable it -->
    <button mat-menu-item (click)="executeFabricWorkspace()" *ngIf="
        project.fabricWorkspaceConfigured &&
        project.status === projectStatusEnum.CREATED.toString() &&
        !project.fabricWorkspaceExecuted &&
        userService.userHasPlatformAdminRole
      ">
      <div class="menu-icon-list">
        <div class="menu-icon-container">
          <img src="assets/images/icons/execute-icon.svg" class="menu-icon" />
          <span class="vertical-dot-menu-text-font"> Execute Fabric Workspace </span>
        </div>
      </div>
    </button>

    <!-- Check if any project admin is assigned and project status is "Configuration Inprogress", then enable it -->
    <button mat-menu-item (click)="openProjectConfigurationPage()"
            *ngIf="project.status === projectStatusEnum.CONFIGURATIONINPROGRESS.toString() && isProjectAdmin">
      <div class="menu-icon-list">
        <div class="menu-icon-container">
          <img src="assets/images/icons/project-configuration.svg" class="menu-icon" />
          <span class="vertical-dot-menu-text-font"> Project Configuration </span>
        </div>
      </div>
    </button>
    <!-- All role can view project details-->
    <button mat-menu-item (click)="openProjectSettingsPage()" *ngIf="showProjectSettingsOption">
      <div class="menu-icon-list">
        <div class="menu-icon-container">
          <img src="assets/images/icons/settings-blue.svg" class="menu-icon" />
          <span class="vertical-dot-menu-text-font"> Project Settings </span>
        </div>
      </div>
    </button>
    <!-- Accessible to only Platform Admin -->
    <button mat-menu-item (click)="openChangeProjectStatusDialog()" *ngIf="showHideRemoveAndChangeProjectStatusMenu()">
      <div class="menu-icon-list">
        <div class="menu-icon-container">
          <img src="assets/images/icons/switch-arrows.svg" class="menu-icon" />
          <span class="vertical-dot-menu-text-font"> Change Project Status </span>
        </div>
      </div>
    </button>
    <!-- Project status change request -->
    <button mat-menu-item (click)="openProjectStatusChangeRequestDialog()" *ngIf="
        (project.status === projectStatusEnum.CONFIGURATIONINPROGRESS.toString() && isProjectAdmin) ||
        (project.status === projectStatusEnum.ACTIVE.toString() && isProjectAdmin) ||
        (project.status === projectStatusEnum.PAUSED.toString() && isProjectAdmin) ||
        (project.status === projectStatusEnum.COMPLETED.toString() && isProjectAdmin) ||
        (project.status === projectStatusEnum.PAUSED.toString() && isProjectAdmin && isProjectAdminCanRequestArchive)
      ">
      <div class="menu-icon-list">
        <div class="menu-icon-container">
          <img src="assets/images/icons/switch-arrows.svg" class="menu-icon" />
          <span class="vertical-dot-menu-text-font"> Request Project Status Change </span>
        </div>
      </div>
    </button>

    <!-- Accessible to only Platform Admin -->
    <!--Do not remove this piece of code,this will required in future-->
    <!--<button mat-menu-item *ngIf="showHideRemoveAndChangeProjectStatusMenu()">
    <div class="menu-icon-list">
      <div class="menu-icon-container">
        <img src="assets/images/icons/remove.svg" class="menu-icon" />
        <span class="vertical-dot-menu-text-font"> Remove Project </span>
      </div>
    </div>
  </button>-->
  </div>
</mat-menu>
